export const APP_BAR_HEIGHT = 40;
export const PADDING = 32;
export const MUTATION_OBSERVER_OPTIONS = {
  attributes: true,
  childList: true,
};
